// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cba3","footer":"styles_footer__ci7xI","passCodeTooltip":"styles_passCodeTooltip__2Msgj"};